import ListingSale from './listingSale'

export default ListingSale
